export const Pagination = {
  Page: 1,
  Size: 10,
  TransactionLimit: 10,
};

export const DashboardPagination = {
  TransactionPage: 1,
  TransactionSize: 20,
  CardPage: 1,
  CardSize: 10,
};

export const PaginationMessage = {
  Page: 1,
  Size: 5,
};
